import React, { useCallback, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import FormValidationError from '@shared/form/form-validation-error/form-validation-error';
import FieldLabel from '@shared/form/field-label/field-label';
import has from 'lodash/has';
import get from 'lodash/get';
import { InputProps } from '../../../../types/form.types';
import FormInputComponents from './form-input.components';
import { useParamsContext } from '../../../../params/params-context';
import { PORTAL_TYPE } from '../../../../types/app.types';

const { Container, StyledInput } = FormInputComponents;

const FormInput: React.FunctionComponent<InputProps> = ({
  name,
  label,
  errorMessage,
  isRequired,
  customWidth,
  showRequiredLegend,
  isNumberType
}) => {
  const { portalType, user } = useParamsContext();
  const { register, trigger, setValue } = useFormContext();
  const [inputValue, setInputValue] = useState<string>(get(user, name, ''));
  const disabledFieldsIds = useMemo(
    () =>
      portalType === PORTAL_TYPE.UMER
        ? ['company_name']
        : ['applicant_id', 'company_name'],
    [portalType]
  );
  const isDisabled = has(user, name) && disabledFieldsIds.includes(name);

  const onChangeHandler = useCallback(
    (event) => {
      setInputValue(event.target.value);
      setValue(name, event.target.value);
      trigger(name);
    },
    [name, setValue, trigger]
  );

  const onBlurHandler = useCallback(
    (event) => {
      setInputValue(event.target.value);
      setValue(name, event.target.value);
      trigger(name);
    },
    [name, setValue, trigger]
  );

  return register ? (
    <Container customWidth={customWidth}>
      <FieldLabel
        text={label}
        isRequired={isRequired}
        showLegend={showRequiredLegend}
      />
      <StyledInput
        {...register(name)}
        data-test-id={name}
        type={isNumberType ? 'number' : 'text'}
        value={inputValue}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        readOnly={isDisabled}
      />
      <FormValidationError errorMessage={errorMessage} />
    </Container>
  ) : null;
};

export default FormInput;
